import { LeagueCombinedConfig, useConfigProperty } from '@leagueplatform/core';

const defaultConfig = {
  showGetAssistanceNowSubheading: false,
  showProviderAvailability: false,
  getCareLandingMasonryQueryParams: undefined,
} satisfies LeagueCombinedConfig['careDiscovery'];

export const useCareDiscoveryConfig = () =>
  useConfigProperty('careDiscovery', defaultConfig);
